import { Observable } from 'rxjs';

import { IFactorConfiguration } from '../models';


export abstract class FactorConfigurationService {
	abstract loadFactorConfig(): Observable<void>;
	abstract getFactorConfig(): Observable<IFactorConfiguration>;
}
